// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Admin {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  font-family: Arial, sans-serif;
}

.Admin h1 {
  color: white; 
  background-color: #0056b3; 
  padding: 15px;
  margin-bottom: 20px;
  border-radius: 5px;
}

.claims-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
  box-shadow: 0 2px 15px rgba(0, 0, 0, 0.1);
  background-color: white;
}

.claims-table th,
.claims-table td {
  padding: 12px 15px;
  text-align: left;
  border-bottom: 1px solid #e0e0e0;
}

.claims-table th {
  background-color: #f8f9fa;
  font-weight: bold;
  color: #333;
  text-transform: uppercase;
  font-size: 0.9em;
}

.claims-table tr {
  background-color: white;
}

.claims-table tr:hover {
  background-color: #f5f5f5;
  transition: background-color 0.3s ease;
}

.claims-table td {
  font-size: 0.95em;
}

.claims-table input[type="checkbox"] {
  cursor: pointer;
}

.status-pending {
  color: #ffa500;
  font-weight: bold;
}

.status-approved {
  color: #28a745;
  font-weight: bold;
}

.status-rejected {
  color: #dc3545;
  font-weight: bold;
}

.selected-count {
  margin-top: 20px;
  font-weight: bold;
}

@media (max-width: 768px) {
  .claims-table {
    font-size: 0.8em;
  }

  .claims-table th,
  .claims-table td {
    padding: 8px 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Admin.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,yCAAyC;EACzC,uBAAuB;AACzB;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;;IAEE,iBAAiB;EACnB;AACF","sourcesContent":[".Admin {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 20px;\n  font-family: Arial, sans-serif;\n}\n\n.Admin h1 {\n  color: white; \n  background-color: #0056b3; \n  padding: 15px;\n  margin-bottom: 20px;\n  border-radius: 5px;\n}\n\n.claims-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 20px;\n  box-shadow: 0 2px 15px rgba(0, 0, 0, 0.1);\n  background-color: white;\n}\n\n.claims-table th,\n.claims-table td {\n  padding: 12px 15px;\n  text-align: left;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.claims-table th {\n  background-color: #f8f9fa;\n  font-weight: bold;\n  color: #333;\n  text-transform: uppercase;\n  font-size: 0.9em;\n}\n\n.claims-table tr {\n  background-color: white;\n}\n\n.claims-table tr:hover {\n  background-color: #f5f5f5;\n  transition: background-color 0.3s ease;\n}\n\n.claims-table td {\n  font-size: 0.95em;\n}\n\n.claims-table input[type=\"checkbox\"] {\n  cursor: pointer;\n}\n\n.status-pending {\n  color: #ffa500;\n  font-weight: bold;\n}\n\n.status-approved {\n  color: #28a745;\n  font-weight: bold;\n}\n\n.status-rejected {\n  color: #dc3545;\n  font-weight: bold;\n}\n\n.selected-count {\n  margin-top: 20px;\n  font-weight: bold;\n}\n\n@media (max-width: 768px) {\n  .claims-table {\n    font-size: 0.8em;\n  }\n\n  .claims-table th,\n  .claims-table td {\n    padding: 8px 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
